import { Link, NavLink, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { useEffect, useState, useRef } from 'react';

function Header() {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const headerRef = useRef(null);

  // Custom scroll function with header offset
  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -88; // Header height offset
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
  };

  // Handles scrolling Header behavior and checking of mobile view.
  useEffect(() => {
    const mobileWidth = 576;
    
    const handleResize = () => {
      const newIsMobile = window.innerWidth <= mobileWidth;
      setIsMobile(newIsMobile);
      
      // Close menu and dropdown when resizing to desktop
      if (window.innerWidth > mobileWidth) {
        setMenuOpen(false);
        setDropdownOpen(false);
      }
    };

    const onScroll = () => {
      const scrollTrigger = 100;
      setIsScrolled(window.scrollY >= scrollTrigger);
    };

    // Initial setup
    handleResize();
    
    // Add listeners
    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Close menus when navigating
  useEffect(() => {
    setMenuOpen(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  // Handle outside clicks
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!headerRef.current?.contains(event.target)) {
        // Close hamburger menu if clicking outside header
        if (menuOpen) setMenuOpen(false);
        
        // Close dropdown if clicking outside and in mobile
        if (isMobile && dropdownOpen) setDropdownOpen(false);
      }
    };

    if (menuOpen || (isMobile && dropdownOpen)) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
      
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('touchstart', handleClickOutside);
      };
    }
  }, [menuOpen, isMobile, dropdownOpen]);
  
  // Handle Core Business click
  const handleCoreBusinessClick = (e) => {
    if (isMobile) {
      e.preventDefault();
      setDropdownOpen(prev => !prev);
    }
  };

  return (
    <header ref={headerRef} className={`header${isScrolled ? ' smaller-size header-white' : ''}`}>
      <div className="company-img-container">
        <Link id="no-deco" to="/">
          <img
            className={`company-img${isScrolled ? ' smaller-logo' : ''}`}
            src={isScrolled ? "/images/general/ELAY-logo.png" : "/images/general/ELAY-logo-white.png"}
            alt="logo"
          />
        </Link>
      </div>
      <nav>
        <ul className={`navigation-menu ${menuOpen ? 'show' : (isMobile ? 'hide-compact' : 'hide-default')}`} id="MenuItems">
          <div className={`drop-settings ${isScrolled ? 'header-white' : ''}`}>
            <li>
              <NavLink to="/aboutus" className={isScrolled ? 'text-green' : ''}>About Us</NavLink>
            </li>
            <li className="dropdown">
              {/* The dropdown toggle */}
              <NavLink 
                to="/corebusiness" 
                id="core-biz" 
                className={isScrolled ? 'text-green' : ''}
                onClick={handleCoreBusinessClick}
              >
                Core Business <i className="fa fa-caret-down" />
              </NavLink>
              {/* Dropdown content */}
              <div className={`dropdown-content ${dropdownOpen ? 'show-menu' : ''}`}>
                <HashLink 
                  smooth to="/corebusiness#prop-dev"
                  scroll={scrollWithOffset}
                  className={`${isScrolled ? 'text-green dropdown-link' : 'dropdown-link'} ${dropdownOpen ? 'show-menu-contents' : ''}`}
                >
                  Property Development
                </HashLink>
                <HashLink 
                  smooth to="/corebusiness#construction"
                  scroll={scrollWithOffset}
                  className={`${isScrolled ? 'text-green dropdown-link' : 'dropdown-link'} ${dropdownOpen ? 'show-menu-contents' : ''}`}
                >
                  Construction
                </HashLink>
              </div>
            </li>
            <li>
              <NavLink to="/keypersonnel" className={isScrolled ? 'text-green' : ''}>Key Personnel</NavLink>
            </li>
            <li>
              <NavLink to="/highlights" className={isScrolled ? 'text-green' : ''}>Highlights</NavLink>
            </li>
            <li>
              <NavLink to="/contactus" className={isScrolled ? 'text-green' : ''}>Contact Us</NavLink>
            </li>
          </div>
        </ul>
      </nav>
      <div className={`${menuOpen ? (isScrolled ? 'menu-icon-selected-light' : 'menu-icon-selected') : ''}`} id="menu-icon" onClick={() => setMenuOpen(prev => !prev)}>
        <i className={`fa fa-bars ${isScrolled ? (!menuOpen ? 'icon-green' : '') : ''}`} />
      </div>
    </header>
  );
}

export default Header; 